{
  "aiGeneratedAnswer": "AI 生成的答案",
  "allCategories": "所有类别",
  "appliedFiltersToCurrentSearch": "已应用于当前搜索的筛选条件",
  "apply": "应用",
  "applyFilters": "应用筛选条件",
  "autocompleteOptionsFound_other": "找到 {{count}} 个{{label}}自动完成选项。",
  "autocompleteSuggestion": "自动完成建议：{{suggestion}}",
  "autocompleteSuggestionsFound_other": "找到 {{count}} 个自动完成建议。",
  "basedOnYourDevice": "（基于您的设备）",
  "basedOnYourInternetAddress": "（基于您的 IP 地址）",
  "categoriesText_other": "以下分类包含与<strong>{{query}}</strong>相关的结果",
  "clearAll": "清除全部",
  "clearMinAndMax": "清除最小值和最大值",
  "clearTheRangeToSelectOptions": "清除以选择选项的范围。",
  "clearTheSearchBar": "清除搜索栏",
  "conductASearch": "进行搜索",
  "currentLocation": "当前位置",
  "didYouMean": "您的意思是 <button>{{correctedQuery}}</button> 吗",
  "dropDownScreenReaderInstructions": "当有自动完成结果时，使用上下箭头浏览，按回车键选择。",
  "feedback": "反馈",
  "filterGroupSearchInputLabel": "搜索{{title}}选项",
  "invalidRange": "无效范围",
  "max": "最大",
  "min": "最小",
  "navigateToTheNextResultsPage": "导航到下一个结果页面",
  "navigateToThePreviousResultsPage": "导航到上一个结果页面",
  "noAutocompleteOptionsFound": "0已找到自动完成选项。",
  "noAutocompleteSuggestionsFound": "0发现自动完成建议。",
  "noResultsFoundIn": "在{{currentVerticalLabel}}中未找到结果。",
  "paginationPage": "第 {{pageNumber}} 页",
  "pagination": "分页",
  "readMoreAbout": "阅读关于<a>{{name}}</a>的更多内容",
  "recentSearch": "最近的搜索：{{query}}",
  "recentSearchesFound_other": "找到 {{count}} 个最近的搜索记录。",
  "removeFilter": "移除“{{displayName}}”筛选器",
  "resultPreview": "结果预览：{{value}}",
  "resultPreviewsFound_other": "找到 {{count}} 个结果预览。",
  "resultsCountText_other": "{{count}} 条结果",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} / 共 {{resultsCount}} 个结果",
  "searchHere": "在此搜索…",
  "showingAllInstead": "正在显示所有{{currentVerticalLabel}}。",
  "showLess": "收起",
  "showMore": "查看更多",
  "sources_other": "来源（{{count}}）",
  "submitSearch": "提交搜索",
  "suggestionResultsCount_other": "{{label}} – {{count}} 个结果",
  "thankYouForYourFeedback": "感谢您的反馈！",
  "thisAnsweredMyQuestion": "这个回答了我的问题",
  "thisDidNotAnswerMyQuestion": "这个没有回答我的问题",
  "unselectAnOptionToEnterInARange": "取消选择某个选项以输入范围。",
  "updateYourLocation": "更新您的位置",
  "useCurrentLocation": "使用当前位置",
  "useMyLocation": "使用我的位置",
  "viewAll": "查看全部",
  "viewDetails": "查看详细信息"
}
